<template>
	<keep-alive :include="keepAliveIncludes">
		<router-view :key="$route.fullPath" />
	</keep-alive>
</template>

<script setup>
import { useKeepAliveInclude } from '@rebuild/hooks/cache/useKeepAliveInclude';
const { keepAliveIncludes } = useKeepAliveInclude();
</script>
